// @flow
import * as React from 'react';
import i18n from 'app/common/lib/i18n';
import StopEventPropagation from 'app/packages/stop-event-propagation/StopEventPropagation';
import Testable from 'app/common/react/ui/Testable';
import { Box, Flyout, Layer, IconButton, Button } from 'gestalt';

type Props = {|
  handleClickReport: ?() => void,
  handleDelete: ?() => void,
  handleOnEdit: ?() => void,
  small?: boolean,
|};

type State = {|
  isFlyoutOpen: boolean,
|};

type FlyoutItemProps = {|
  action: () => void,
  label: string,
  testId: string,
|};

export const FlyoutItem = ({ action, label, testId }: FlyoutItemProps) => (
  <Testable id={`flyout-item-${testId}`}>
    <Button accessibilityLabel={label} color="white" text={label} onClick={action} />
  </Testable>
);

export class ActivityItemFlyout extends React.PureComponent<Props, State> {
  static defaultProps = {
    handleClickReport: null,
    handleDelete: null,
    handleOnEdit: null,
  };

  state = {
    isFlyoutOpen: false,
  };

  flyoutAnchor: ?HTMLElement;

  toggleFlyout = (event: ?Object) => {
    const e = (event || {}).event || {};
    if (e.preventDefault) {
      e.preventDefault();
      e.stopPropagation();
    }
    this.setState({ isFlyoutOpen: !this.state.isFlyoutOpen });
  };

  render() {
    const { handleClickReport, handleDelete, handleOnEdit, small } = this.props;

    const { isFlyoutOpen } = this.state;
    const showFlyout = handleClickReport || handleDelete || handleOnEdit;

    if (!showFlyout) {
      return null;
    }

    return (
      <Box display="flex" direction="column" alignItems="end">
        <Box>
          <div
            ref={(c) => {
              this.flyoutAnchor = c;
            }}
          >
            <Testable id="flyout-toggle">
              <IconButton
                accessibilityExpanded={isFlyoutOpen}
                accessibilityHaspopup
                accessibilityLabel={i18n._(
                  'more options',
                  'accessible label for button to see more options on report content',
                )}
                icon="ellipsis"
                onClick={this.toggleFlyout}
                size={small ? 'sm' : 'md'}
              />
            </Testable>
          </div>
          {isFlyoutOpen && (
            <Layer>
              <StopEventPropagation>
                <Testable id="flyout">
                  <Flyout
                    anchor={this.flyoutAnchor}
                    idealDirection="down"
                    onDismiss={this.toggleFlyout}
                    positionRelativeToAnchor={false}
                    size="sm"
                  >
                    <Box width="100%">
                      {handleOnEdit && (
                        <FlyoutItem
                          action={handleOnEdit}
                          label={i18n._('Edit', 'Edit a community post or comment')}
                          testId="edit"
                        />
                      )}
                      {handleDelete && (
                        <FlyoutItem
                          action={handleDelete}
                          label={i18n._('Delete', 'Delete a community post or comment')}
                          testId="delete"
                        />
                      )}
                      {handleClickReport && (
                        <FlyoutItem
                          action={handleClickReport}
                          label={i18n._(
                            'Report this content',
                            'Report a community post or comment',
                          )}
                          testId="report"
                        />
                      )}
                    </Box>
                  </Flyout>
                </Testable>
              </StopEventPropagation>
            </Layer>
          )}
        </Box>
      </Box>
    );
  }
}

export default ActivityItemFlyout;
